import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthRoute } from './auth/AuthRoute';
import { AppShell } from '@components/AppShell';
import { AuthErrorBanner } from '@components/AuthErrorBanner';
import { Login } from '@pages/Login';
import { Bench } from '@pages/Bench';
import { Testing } from '@pages/Testing';
import { Review } from '@pages/Review';
import { Archive } from '@pages/Archive';
import { Turnaround } from '@pages/Turnaround';
import { useIdleLogoff } from '@lib/idle-logoff';

export function App() {
  useIdleLogoff();
  return (
    <>
      <AuthErrorBanner />
      <Routes>
        <Route path="/login" element={<Login />} />
        {/* MSAL processes the redirect response in main.tsx before render; bounce to home. */}
        <Route path="/login/callback" element={<Navigate to="/" replace />} />
        <Route
          path="/"
          element={
            <AuthRoute>
              <AppShell />
            </AuthRoute>
          }
        >
          <Route index element={<Bench />} />
          <Route path="testing" element={<Testing />} />
          <Route path="review" element={<Review />} />
          <Route path="archive" element={<Archive />} />
          <Route path="turnaround" element={<Turnaround />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
